import { useNavigate } from 'react-router-dom'

const OBJECT_TYPES: { value: string; label: string }[] = [
  { value: 'contract', label: 'Umowa' },
  { value: 'annex', label: 'Aneks' },
  { value: 'product', label: 'Produkt (element)' },
]

/** Przełącznik typu obiektu w Form Builderze - nawiguje na /settings/forms/{type}. */
export function FormBuilderObjectTypeTabs({ active }: { active: string }) {
  const navigate = useNavigate()
  return (
    <nav className="flex gap-1" aria-label="Typ obiektu">
      {OBJECT_TYPES.map(o => (
        <button
          key={o.value}
          type="button"
          onClick={() => navigate(`/settings/forms/${o.value}`)}
          className={`text-xs px-3 py-1 rounded-t border-b-2 transition ${
            active === o.value
              ? 'border-sky-600 text-sky-700 font-semibold'
              : 'border-transparent text-slate-500 hover:text-slate-700'
          }`}
        >
          {o.label}
        </button>
      ))}
    </nav>
  )
}
